// Axios
import axiosInstance from '../axios/axiosInstance';

// Sign in a user
const login = async (data) => {
  const res = await axiosInstance.post(`api/token/`, data);
  return res.data;
};

const logout = () => {
  localStorage.removeItem('user');
};

const permission = async () => {
  const res = await axiosInstance.get(`permissions/user`);
  return res.data;
};

const getUsers = async () => {
  const res = await axiosInstance.get(`atualizar/user/`);
  return res.data;
};

const authService = {
  login,
  logout,
  permission,
  getUsers,
};

export default authService;
